import React, { useEffect, useState } from "react";
import { Input, Modal, message } from "antd";
import { SystemVersion } from "../../../../Api";

interface VersionModalProps {
  open: boolean;
  editing: SystemVersion | null;
  saving: boolean;
  onClose: () => void;
  onSave: (payload: { version: string; notes?: string }) => void;
}

export const VersionModal: React.FC<VersionModalProps> = ({
  open,
  editing,
  saving,
  onClose,
  onSave,
}) => {
  const [versionInput, setVersionInput] = useState("");
  const [notesInput, setNotesInput] = useState("");

  useEffect(() => {
    if (open) {
      if (editing) {
        setVersionInput(editing.version);
        setNotesInput(editing.notes || "");
      } else {
        setVersionInput("");
        setNotesInput("");
      }
    }
  }, [open, editing]);

  const handleOk = () => {
    if (!versionInput.trim()) {
      message.warning("Version is required.");
      return;
    }
    onSave({
      version: versionInput.trim(),
      notes: notesInput,
    });
  };

  return (
    <Modal
      title={editing ? "Edit Version" : "Add Version"}
      open={open}
      onOk={handleOk}
      confirmLoading={saving}
      onCancel={onClose}
      okText={editing ? "Update" : "Create"}
      destroyOnClose
    >
      <div className="space-y-4 pt-4">
        <div>
          <label className="block text-sm font-medium mb-1">Version *</label>
          <Input
            placeholder="e.g. 1.2.0"
            value={versionInput}
            onChange={(e) => setVersionInput(e.target.value)}
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">
            Release Notes
          </label>
          <Input.TextArea
            rows={5}
            placeholder="Describe what changed in this version..."
            value={notesInput}
            onChange={(e) => setNotesInput(e.target.value)}
          />
        </div>
      </div>
    </Modal>
  );
};
